// extracted by mini-css-extract-plugin
module.exports = {"FeaturedClientHero":"styles_FeaturedClientHero__4EBpa","img":"styles_img__7zxUG","bg_1":"styles_bg_1__ksFqC","height":"styles_height__K4lPL"};